import {
  CellContext,
  createColumnHelper
} from "@tanstack/react-table";

import { customCreateColumnHelper } from "src/core/dashboard/components/widgets/table/customColumnHelper";
import { BranchWastageGrouped } from "src/modules/waste/api/waste.api";

export interface BranchWastageGroupedTableColumnParams {
  actionButton: (info: CellContext<BranchWastageGrouped, unknown>) => React.ReactNode;
}

export const branchWastageGroupedTableColumns = (params: BranchWastageGroupedTableColumnParams) => {
  const customColumnHelper = customCreateColumnHelper<BranchWastageGrouped>();
  const columnHelper = createColumnHelper<BranchWastageGrouped>();

  return [
    customColumnHelper.dateColumn(columnHelper, "wasteDate", { header: "Waste Date" }),
    customColumnHelper.numberColumn(columnHelper, "totalProducts", {
      header: "Total Products",
      enableColumnFilter: false
    }),
    customColumnHelper.standardTextColumn(columnHelper, "reportedBy", {
      header: "Reported By",
      enableColumnFilter: false
    }),
    customColumnHelper.actionColumn(columnHelper, params.actionButton, { size: 200 })
  ];
};
